import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

let nextId = 0;

/**
 * Animated Sharegain mark (design "Combo" loader). Decorative: pair it with
 * status text. The SMIL morph can't be stopped by CSS, so it is only rendered
 * when the user allows motion (read once on creation).
 */
@Component({
  selector: 'sg-logo-loader',
  templateUrl: './sg-logo-loader.component.html',
  styleUrls: ['./sg-logo-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgLogoLoaderComponent {
  /** Rendered height of the mark in px; the width follows the mark's 3:4 aspect ratio. */
  @Input() size = 30.2;

  /** Gradient ids are document-global, so each instance gets its own. */
  protected readonly ids = (() => {
    const n = nextId++;
    return { top: `sg-logo-loader-gt-${n}`, bottom: `sg-logo-loader-gb-${n}`, band: `sg-logo-loader-gr-${n}` };
  })();

  protected readonly animate =
    typeof window === 'undefined' || !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
